import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import ContactSection from './components/ContactSection';
import FloatingAIChat from './components/FloatingAIChat';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import PageTransition from './components/PageTransition';
import { AIChatProvider } from './context/AIChatContext';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import AIAssistantPage from './pages/AIAssistantPage';
import AudiencePage from './pages/AudiencePage';
import FounderPage from './pages/FounderPage';
import HomePage from './pages/HomePage';
import IdeasPage from './pages/IdeasPage';
import MarketingPage from './pages/MarketingPage';
import MediaInitiativePage from './pages/MediaInitiativePage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import ServicesPage from './pages/ServicesPage';
import PhaseOnePage from './pages/PhaseOnePage';
import InvestmentPage from './pages/InvestmentPage';
import SportsClubsPage from './pages/SportsClubsPage';
import StrategyPage from './pages/StrategyPage';
import VisualHubPage from './pages/VisualHubPage';
import WhoWeArePage from './pages/WhoWeArePage';

function AppLayout() {
  const { isArabic } = useLanguage();

  return (
    <div className={`page ${isArabic ? 'rtl' : ''}`}>
      <Navbar />
      <PageTransition>
        {(displayLocation) => (
          <Routes location={displayLocation}>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
            <Route path="/audience" element={<AudiencePage />} />
            <Route path="/founder" element={<FounderPage />} />
            <Route path="/strategy" element={<StrategyPage />} />
            <Route path="/phase-one" element={<PhaseOnePage />} />
            <Route path="/investment" element={<InvestmentPage />} />
            <Route path="/marketing" element={<MarketingPage />} />
            <Route path="/media-initiative" element={<MediaInitiativePage />} />
            <Route path="/sports-clubs" element={<SportsClubsPage />} />
            <Route path="/visual-hub" element={<VisualHubPage />} />
            <Route path="/ideas" element={<IdeasPage />} />
            <Route path="/who-we-are" element={<WhoWeArePage />} />
            <Route path="/ai-assistant" element={<AIAssistantPage />} />
          </Routes>
        )}
      </PageTransition>
      <ContactSection />
      <Footer />
      <FloatingAIChat />
      <FloatingWhatsApp />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AIChatProvider>
          <AppLayout />
        </AIChatProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
